module.exports = {
          srcSet: __webpack_public_path__ + "4d4cb542916b27f5d9a605d7880e43eb-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "4d4cb542916b27f5d9a605d7880e43eb-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "4d4cb542916b27f5d9a605d7880e43eb-120.png",
          toString:function(){return __webpack_public_path__ + "4d4cb542916b27f5d9a605d7880e43eb-120.png"},
          
          width: 120,
          height: 120
        }